const Menu = [
  {
    label: "Home",
    pathname: "/avaliador/home"
  },
  {
    label: "Papers para Avaliar", 
    pathname: "/avaliador/papers-para-avaliar",
  },
  {
    label: "Logout",
    pathname: "/logout"
  },
]

export default Menu;